import { LEGAL_DOCUMENTS_EVENTS } from '../../event_bus_modules/legal_documents';

$(() => {
  const downloadsSection = $('#downloads');
  const propertyId = $('#_property-id').val();
  const entityId = $('#_entity-id').val();
  const isUserAuthenticated = $('#_is-user-authenticated').val() === 'True';

  const legalDocumentsShowContentButton = $('#legal-documents-show-content');
  const legalDocumentsContent = $('#legal-documents-content');

  const legalDocumentsShowModalButton = $('#legal-documents-show-modal');
  const legalDocumentsModal = $('#legal-documents-modal');

  const legalDocumentsHideContentButton = $('#legal-documents-hide-content');
  const legalDocumentsApiErrorMessage = $('#legal-documents-api-error-message');

  const documentsSubscriberCountryId = $('#documents_subscriber_country_id');

  const shouldVerifyUserInterestInLegalDocuments = () => {
    const legalDocumentsTable = $('#legal-documents-table');
    return legalDocumentsTable.length === 0;
  };

  const showLegalDocumentsSection = () => {
    legalDocumentsContent.css('display', 'flex');
    legalDocumentsShowModalButton.hide();
    legalDocumentsShowModalButton.prop('disabled', false);
    legalDocumentsHideContentButton.prop('disabled', false);
    legalDocumentsHideContentButton.show();
  };

  const loadLegalDocumentsTable = (subscriberCountryId = null) => {
    EVENT_BUS.dispatch(LEGAL_DOCUMENTS_EVENTS.GET_LEGAL_DOCUMENTS_TABLE, {
      propertyId: propertyId,
      entityId: entityId,
      subscriberCountryId: subscriberCountryId,
    });
  };

  EVENT_BUS.on(
    LEGAL_DOCUMENTS_EVENTS.USER_IS_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
    () => {
      loadLegalDocumentsTable();
    }
  );

  EVENT_BUS.on(
    LEGAL_DOCUMENTS_EVENTS.USER_IS_NOT_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
    () => {
      legalDocumentsModal.modal('show');
      legalDocumentsShowModalButton.prop('disabled', false);
    }
  );

  EVENT_BUS.on(
    LEGAL_DOCUMENTS_EVENTS.LEGAL_DOCUMENTS_TABLE_LOADED,
    ({ data }) => {
      const legalDocumentsTable = $('#legal-documents-table');
      if (legalDocumentsTable.length == 0) {
        legalDocumentsContent.append(data);
      } else {
        legalDocumentsTable.replaceWith(data);
      }
      showLegalDocumentsSection();
    }
  );

  EVENT_BUS.on(LEGAL_DOCUMENTS_EVENTS.LEGAL_DOCUMENTS_API_ERROR, () => {
    const legalDocumentsTable = $('#legal-documents-table');
    legalDocumentsTable.hide();
    legalDocumentsContent.css('display', 'flex');
    legalDocumentsApiErrorMessage.show();
  });

  const onLegalDocumentsShowModalButtonClicked = () => {
    if (isUserAuthenticated) {
      legalDocumentsShowModalButton.prop('disabled', true);
      if (shouldVerifyUserInterestInLegalDocuments()) {
        EVENT_BUS.dispatch(
          LEGAL_DOCUMENTS_EVENTS.IS_USER_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
          {
            propertyId: propertyId,
            entityId: entityId,
          }
        );
      } else {
        loadLegalDocumentsTable();
      }
    } else {
      showLegalDocumentsSection();
      legalDocumentsHideContentButton.prop('disabled', false);
    }
  };

  const onShowLegalDocumentsButtonClicked = () => {
    if (isUserAuthenticated) {
      legalDocumentsShowModalButton.prop('disabled', true);
      documentsSubscriberCountryId.is(':checked')
        ? loadLegalDocumentsTable(documentsSubscriberCountryId.val())
        : loadLegalDocumentsTable();
    } else {
      showLegalDocumentsSection();
      legalDocumentsHideContentButton.prop('disabled', false);
    }
  };

  const onLegalDocumentsHideContentButtonClicked = () => {
    legalDocumentsContent.hide();
    legalDocumentsHideContentButton.hide();
    legalDocumentsShowModalButton.show();
  };

  if (document.cookie.includes('action=legal_documents')) {
    onLegalDocumentsShowModalButtonClicked();
    window.scrollTo({
      top: downloadsSection.offset().top,
      behavior: 'smooth',
    });
    document.cookie = 'action=; path=/; Max-Age=-99999999;';
  }

  legalDocumentsShowContentButton.on(
    'click',
    onShowLegalDocumentsButtonClicked
  );
  legalDocumentsShowModalButton.on(
    'click',
    onLegalDocumentsShowModalButtonClicked
  );
  legalDocumentsHideContentButton.on(
    'click',
    onLegalDocumentsHideContentButtonClicked
  );
});
